module.exports = __webpack_public_path__ + "img/get-energy-logo.5fcfeaea.jpg";